"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  contained: {
    marginLeft: 14,
    marginRight: 14
  }
};
var _default = exports.default = {
  styleOverrides
};
